import * as React from 'react'
import { Row, Col, Button, Alert } from 'reactstrap'
import axios from 'axios'
import BankDetails from '../../../common/bankdetails/BankDetails'
import { withRouter } from 'react-router-dom'
import ConfirmModal from './ConfirmModal'
import { Constants } from '../../constants'
import forEach from 'lodash/forEach'
import { UserContext } from './../common/UserContext'

interface BankViewState {
  data: any
  loading: boolean
  bankName: string
  fund: string
  failDate: string
  fiscalYear: string
  fiscalQuarter: string
  assets: any
  liabilities: any
  claimsProven: any
  claimsOther: any
  published: boolean
  message: any
}

class BankView extends React.Component<any, BankViewState> {
  // Contructor
  constructor (props: any) {
    super(props)
    this.state = {
      loading: false,
      data: {},
      bankName: '',
      fund: '',
      failDate: '',
      fiscalYear: '',
      fiscalQuarter: '',
      assets: {},
      liabilities: {},
      claimsProven: {},
      claimsOther: {},
      published: false,
      message: { type: '', isOpen: false, text: '' }
    }

    this.onBackActionHandler = this.onBackActionHandler.bind(this)
    this.onSaveActionHandler = this.onSaveActionHandler.bind(this)
    this.onCancelActionHandler = this.onCancelActionHandler.bind(this)
    this.onAlertCloseAction = this.onAlertCloseAction.bind(this)
    this.isValidDataSet = this.isValidDataSet.bind(this)
  }

  /**
   * Force the loading of the bank data once the page is rendered
   */
  componentDidMount () {
    this.setState({ loading: true })
    this.getBankData()
  }

  /**
   * Fetch the bank data
   */
  getBankData = () => {
    if (this.props.bankid) {
      const URI =
        Constants.APP_API +
        Constants.BANKDETAILS_FETCH_URI +
        '/' +
        this.props.bankid
      axios
        .get(Constants.BANKLIST_USER_TOKEN)
        .then(response => {
          let headerData = {
            Accept: 'application/json',
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + response.data
          }
          axios
            .get(URI, { headers: headerData })
            .then(resp => this.loadBankData(resp.data))
            .catch(err => {
              console.log(err)
              this.dataLoadErrorAlert()
              return null
            })
        })
        .catch(err => {
          console.log(err)
          this.dataLoadErrorAlert()
          return null
        })
    } else {
      this.noFundErrorAlert()
    }
  }

  /**
   * Notify the user that the bank list data filed to load
   */
  dataLoadErrorAlert () {
    this.setState({
      message: {
        type: 'danger',
        isOpen: true,
        text: Constants.BANKDETAILS_ERROR_LOAD
      }
    })
  }

  /**
   * Notify the user that the bank list data filed to load
   */
  noFundErrorAlert () {
    this.setState({
      message: {
        type: 'danger',
        isOpen: true,
        text: Constants.BANKDETAILS_ERROR_NOFUND
      }
    })
  }

  /**
   * Handle the loading of the bank dats
   */
  loadBankData = (data: any) => {
    // testing purposes
    data.fund = '' + this.props.fundCode
    data.name = data.legalName + ' - ' + this.props.fundCode

    this.setState({
      data: data,
      loading: false,
      bankName: data.legalName,
      fund: '' + data.fundCode,
      failDate: data.inceptionDate,
      fiscalYear: data.fiscalYear,
      fiscalQuarter: data.fiscalQuarter,
      assets: {
        cash: data.cashAndInvestmentsAmount,
        due: data.dueFromFdicCorpAndReceivables,
        liquid: data.assetsInLiquidationAmount,
        loss: data.estimatedLossOnAssetsInLiquidationAmount,
        total: data.totalAssetsAmount
      },
      liabilities: {
        admin: data.administrativeLiabilitiesAmount,
        subrogated: data.fdicSubrogatedDepositClaimAmount,
        uninsured: data.uninsuredDepositClaimsAmount,
        other: data.otherClaimaintLiabilitiesAmount,
        unproven: data.unprovenClaimsAmount,
        totalLiab: data.totalLiabilitiesAmount,
        net: data.netWorthAmount,
        total: data.totalLiabilitiesAndNetWorthAmount
      },
      claimsProven: {
        subrogated: [
          data.provenFdicSubrogatedClaimAmount,
          data.provenFdicSubrogatedClaimPercent
        ],
        unisured: [
          data.provenUninsuredDepositorsAmount,
          data.provenUninsuredDepositorsPercent
        ],
        subTotal: [
          data.subTotalProvenDepositClaimsAmount,
          data.subTotalProvenDepositClaimsPercent
        ],
        dividendsPaid: [
          data.provenDividendsPaidToDateAmount,
          data.provenDividendsPaidToDatePercent
        ],
        total: [
          data.totalUnpaidDepositClaimsAmount,
          data.totalUnpaidDepositClaimsPercent
        ]
      },
      claimsOther: {
        general: [data.generalCreditorAmount, data.generalCreditorPercent],
        seniorDebt: [
          data.seniorDebtHoldersAmount,
          data.seniorDebtHoldersPercent
        ],
        subDebt: [
          data.subordinatedDebtHoldersAmount,
          data.subordinatedDebtHoldersPercent
        ],
        subTotal: [
          data.subTotalOtherClaimaintsAmount,
          data.subTotalOtherClaimaintsPercent
        ],
        dividendsPaid: [
          data.otherDividendsPaidToDateAmount,
          data.otherDividendsPaidToDatePercent
        ],
        total: [
          data.totalUnpaidOtherClaimaintsAmount,
          data.totalUnpaidOtherClaimaintsPercent
        ]
      },
      published: data.published
    })
  }

  /**
   * Check to see if the inputed values are valid
   */
  isValidDataSet = () => {
    let isValid = true
    let that = this

    // loop through each element we need to check
    //forEach(["liab3", "liab4", "other0", "other1", "other2"], function(value:any) {
    forEach(
      ['liab4', 'other0', 'other1', 'other2', 'subro0', 'liab1'],
      function (value: any) {
        // get value

        const sAmount: string = that._getInputValueByElementId(value)
        const iAmount: number = parseInt(sAmount)

        // check if it isa proper integer, else set to isValid to false
        if (!Number.isInteger(iAmount) || sAmount !== '' + iAmount) {
          isValid = false
        }
      }
    )

    // if there where any invalid amount the result should be false;
    return isValid
  }

  /**
   * Returns the appropriat Action buttons for the type of status
   */
  actionButtons = (isEditMode: boolean) => {
    if (isEditMode) {
      return (
        <React.Fragment>
          <Button
            className='detailsButton'
            color='primary'
            onClick={() => this.onBackActionHandler()}
          >
            Back
          </Button>
          <ConfirmModal
            buttonLabel='Save Bank'
            className='mymodal'
            onConfirm={this.onSaveActionHandler}
            onCancel={this.onCancelActionHandler}
            validation={this.isValidDataSet}
            groupClassName='dataDetailsActionGroup'
          />
        </React.Fragment>
      )
    }
    return (
      <React.Fragment>
        <Button
          className='detailsButton'
          color='primary'
          onClick={() => this.onBackActionHandler()}
        >
          Back
        </Button>
      </React.Fragment>
    )
  }

  /**
   * Back Button Action Handler
   */
  onBackActionHandler () {
    if (this.props.history && this.props.history.goBack) {
      this.props.history.goBack()
    } else {
      this.props.history.push('../')
    }
  }

  /**
   * Save button Action Handler
   */
  onSaveActionHandler () {
    // Validate the input data
    if (!this.isValidDataSet()) {
      this.setState({
        message: {
          type: 'danger',
          isOpen: true,
          text: Constants.BANKDETAILS_SAVE_INVALID
        }
      })

      return
    }

    // get original data
    let data = this.state.data

    // combine data
    data.otherClaimaintLiabilitiesAmount = this._getInputValueAsIntByElementId("liab3");
    data.unprovenClaimsAmount = this._getInputValueAsIntByElementId("liab4");
    data.generalCreditorAmount = this._getInputValueAsIntByElementId("other0");
    data.seniorDebtHoldersAmount = this._getInputValueAsIntByElementId("other1");
    data.subordinatedDebtHoldersAmount = this._getInputValueAsIntByElementId("other2");
    data.otherDividendsPaidToDateAmount = this._getInputValueAsIntByElementId("other4"); 
    data.fdicSubrogatedDepositClaimAmount = this._getInputValueAsIntByElementId("liab1"); 
    data.provenFdicSubrogatedClaimAmount = this._getInputValueAsIntByElementId("subro0"); 
    

    // Save Data
    axios
      .get(Constants.BANKLIST_USER_TOKEN)
      .then(response => {
        let headerData = {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: 'Bearer ' + response.data
        }
        axios
          .post(Constants.APP_API + Constants.BANKDETAILS_FETCH_URI, data, {
            headers: headerData
          })
          .then(resp => this._saveBankSuccess(resp))
          .catch(error => this._saveBankFailed(error))
      })
      .catch(err => {
        console.log(err)
        this._saveBankFailed(err)
        return null
      })
  }

  /**
   * InvalidData
   */
  _invalidDataMessage (error: any) {
    this.setState({
      message: {
        type: 'danger',
        isOpen: true,
        text: Constants.BANKDETAILS_SAVE_FAILED
      }
    })
  }

  /**
   * Successfull Bank save functionlity
   */
  _saveBankSuccess (response: any) {
    this.setState(
      {
        message: {
          type: 'success',
          isOpen: true,
          text: Constants.BANKDETAILS_SAVE_SUCCESS
        }
      },
      () => {
        this.loadBankData(response.data)
      }
    )
  }

  /**
   * Failed Bank save functionlity
   */
  _saveBankFailed (error: any) {
    this.setState({
      message: {
        type: 'danger',
        isOpen: true,
        text: Constants.BANKDETAILS_SAVE_FAILED
      }
    })
  }

  _getInputValueByElementId (id: string) {
    let value: string = (document.getElementById(id) as HTMLInputElement).value

    value = (value || '0').replace(/\$|,/g, '')
    return value
  }

  _getInputValueAsIntByElementId (id: string) {
    const iValue: number = parseInt(this._getInputValueByElementId(id))
    return iValue || 0
  }

  /**
   * Cancel save
   */
  onCancelActionHandler () {
    //console.log("Boop: cancel");
  }

  /**
   * Close the error Message alert
   */
  onAlertCloseAction () {
    this.setState({
      message: { type: '', isOpen: false, text: '' }
    })
  }

  render () {
    console.log(`cP= ${this.state.claimsProven}`)
    console.log(`cO= ${this.state.claimsOther}`)
    let isEditMode: boolean = false
    let isReadonly: boolean = this.context.isReadOnly
    if (!this.state.published && !isReadonly) {
      isEditMode = true
    }
    let xl1, xl2, xl3, xl4
    switch (this.state.fund.trim()) {
      case '10539':
        xl1 = Constants.FOOTNOTE1_10539
        xl2 = Constants.FOOTNOTE2_10539
        xl3 = Constants.FOOTNOTE3_10539
        xl4 = null
        break
      case '15040':
        xl1 = Constants.FOOTNOTE1_10540
        xl2 = Constants.FOOTNOTE2_10540
        xl3 = Constants.FOOTNOTE3_10540
        xl4 = null
        break
      case '10541':
        xl1 = Constants.FOOTNOTE1_10541
        xl2 = Constants.FOOTNOTE2_10541
        xl3 = Constants.FOOTNOTE3_10541
        xl4 = Constants.FOOTNOTE4_10541
        break
      case '10542':
        xl1 = Constants.FOOTNOTE1_10542
        xl2 = Constants.FOOTNOTE2_10542
        xl3 = Constants.FOOTNOTE3_10542
        xl4 = Constants.FOOTNOTE4_10542
        break
      default:
        xl1 = null
        xl2 = null
        xl3 = null
        xl4 = null
    }
    // This section is here because the fund number wasn't always picked up
    if (this.state.bankName.toUpperCase().trim() === 'SILICON VALLEY BANK') {
      xl1 = Constants.FOOTNOTE1_10539
      xl2 = Constants.FOOTNOTE2_10539
      xl3 = Constants.FOOTNOTE3_10539
      xl4 = null
    }
    if (this.state.bankName.toUpperCase().trim() === 'SIGNATURE BANK') {
      xl1 = Constants.FOOTNOTE1_10540
      xl2 = Constants.FOOTNOTE2_10540
      xl3 = Constants.FOOTNOTE3_10540
    }
    if (this.state.bankName.toUpperCase().trim() === 'SIGNATURE BRIDGE BANK') {
      xl1 = Constants.FOOTNOTE1_10541
      xl2 = Constants.FOOTNOTE2_10541
      xl3 = Constants.FOOTNOTE3_10541
      xl4 = Constants.FOOTNOTE4_10541
    }
    if (
      this.state.bankName.toUpperCase().trim() === 'SILICON VALLEY BRIDGE BANK'
    ) {
      xl1 = Constants.FOOTNOTE1_10542
      xl2 = Constants.FOOTNOTE2_10542
      xl3 = Constants.FOOTNOTE3_10542
      xl4 = Constants.FOOTNOTE4_10542
    }
    return (
      <div className='bankDetails'>
        <Alert
          color={this.state.message.type}
          isOpen={this.state.message.isOpen}
          toggle={this.onAlertCloseAction}
        >
          {this.state.message.text}
        </Alert>
        <Row className='detailsButton'>
          <Col md='12' lg='12' sm='auto'>
            {this.actionButtons(isEditMode)}
          </Col>
        </Row>
        <Row>
          <Col md='12' lg='12' sm='auto'>
            <BankDetails
              key={this.state.fund}
              isEditMode={isEditMode}
              name={this.state.bankName}
              fund={this.state.fund}
              failedDate={this.state.failDate}
              fiscalYear={this.state.fiscalYear}
              fiscalQuarter={this.state.fiscalQuarter}
              assets={this.state.assets}
              liabilities={this.state.liabilities}
              claimsProven={this.state.claimsProven}
              claimsOther={this.state.claimsOther}
            />
          </Col>
        </Row>
        <Row className='detailsButton'>
          <Col md='12' lg='12' sm='auto'>
            {this.actionButtons(isEditMode)}
          </Col>
        </Row>
        <hr />
        <div className='x1'>
          <p>{xl1}</p>
        </div>
        <div className='x2'>
          <p>{xl2}</p>
        </div>
        <div className='x3'>
          <p>{xl3}</p>
        </div>
        <div className='x4'>
          <p>{xl4}</p>
        </div>
        <div className='legal'>
          <sup>
            <a id='details1' href='#details1'>
              (1)
            </a>
          </sup>
          {Constants.BANKDETAILS_DESCRIPTION1}
        </div>
        <div className='legal'>
          <sup>
            <a id='details2' href='#details2'>
              (2)
            </a>
          </sup>
          {Constants.BANKDETAILS_DESCRIPTION2}
        </div>
        <div className='legal'>
          <sup>
            <a id='details3' href='#details3'>
              (3)
            </a>
          </sup>
          {Constants.BANKDETAILS_DESCRIPTION3}
        </div>
        <div className='legal'>
          <sup>
            <a id='details4' href='#details4'>
              (4)
            </a>
          </sup>
          {Constants.BANKDETAILS_DESCRIPTION4}
        </div>
      </div>
    )
  }
}
BankView.contextType = UserContext
export default withRouter(BankView)
